import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ServicePage, serviceMetadata, findService } from './routeExports';
import '../ai/aiServices.css';
import './services.css';
import '../people/people.css';

export default function ServiceRoute() {
  const { slug } = useParams();
  const [query, setQuery] = useState('');
  const service = findService(slug);
  const missing = Boolean(slug && !service);
  useEffect(() => { if (service?.existing) window.location.replace(service.path); }, [service]);
  useEffect(() => {
    if (service?.existing) return;
    const meta = serviceMetadata(service);
    const originalTitle = document.title;
    const restore = [];
    const setTag = (selector, tag, attributes) => {
      let element = document.head.querySelector(selector);
      if (element) {
        const original = Array.from(element.attributes).map(attribute => [attribute.name, attribute.value]);
        const target = element;
        restore.push(() => { Array.from(target.attributes).forEach(attribute => target.removeAttribute(attribute.name)); original.forEach(([name, value]) => target.setAttribute(name, value)); });
      } else {
        element = document.createElement(tag);
        document.head.appendChild(element);
        const target = element;
        restore.push(() => target.remove());
      }
      Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
      return element;
    };
    document.title = missing ? 'Service not found | Blake Technologies' : meta.title;
    setTag('meta[name="description"]', 'meta', { name: 'description', content: missing ? 'Explore software development and technology services from Blake Technologies.' : meta.description });
    if (missing) setTag('meta[name="robots"]', 'meta', { name: 'robots', content: 'noindex, nofollow' });
    else {
      setTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: meta.canonical });
      for (const [property, content] of Object.entries({ 'og:type': 'website', 'og:site_name': 'Blake Technologies', 'og:title': meta.title, 'og:description': meta.description, 'og:url': meta.canonical })) setTag(`meta[property="${property}"]`, 'meta', { property, content });
      for (const [name, content] of Object.entries({ 'twitter:card': 'summary', 'twitter:title': meta.title, 'twitter:description': meta.description })) setTag(`meta[name="${name}"]`, 'meta', { name, content });
      const structured = document.createElement('script');
      structured.type = 'application/ld+json'; structured.textContent = JSON.stringify(meta.structured);
      document.head.appendChild(structured); restore.push(() => structured.remove());
    }
    return () => { document.title = originalTitle; restore.reverse().forEach(fn => fn()); };
  }, [service, missing]);
  if (missing) return <main className="ai-page ai-section"><div className="ai-container"><h1>Service not found</h1><p>This service page is not available.</p><a href="/services">Explore our services</a></div></main>;
  if (service?.existing) return <main className="ai-page ai-section"><div className="ai-container"><a href={service.path}>Continue to {service.title}</a></div></main>;
  return <ServicePage service={service} query={query} setQuery={setQuery} />;
}
